module.exports = "<input ng-disabled=vm.isDisabled ng-required=true data-provide=typeahead fb-set-focus=vm.hasFocus ng-model=vm.searchString id=\"{{vm.inputId}}\" name=\"{{vm.inputId}}\" type=text autocomplete=\"'off'\" ng-class=\"vm.inputStyle ? vm.inputStyle : 'input'\"/>";


//////////////////
// WEBPACK FOOTER
// ./features/common/typeahead.html
// module id = 590
// module chunks = 0